/**
 * La sélection multiple d'une liste d'activités — l'état d'interface partagé par « À faire » et
 * les archives, qui portent le même geste de groupe (archiver / restaurer).
 *
 * Recopie les quatre gestes du legacy, qui les éparpille sur trois affordances
 * (`TodoListScreen.js:165-174`, `:482-491`, `:909-994`, `ArchivedActivitiesScreen.js:146-160`) :
 * l'appui long ouvre la sélection sur une ligne, le lien l'ouvre vide, « Tout sélectionner »
 * bascule entre tout et rien, la croix sort.
 */
export type ActivityId = string | number

export type SelectionState = {
    selectionMode: boolean
    selectedIds: ActivityId[]
}

export type SelectionAction =
    /** Appui long (avec l'activité touchée) ou lien « Sélectionner » (sans). */
    | { type: "START"; id?: ActivityId }
    | { type: "TOGGLE"; id: ActivityId }
    /** Tout / rien, sur les identifiants actuellement affichés. */
    | { type: "TOGGLE_ALL"; ids: ActivityId[] }
    /** La croix, et la sortie après un geste réussi. */
    | { type: "CANCEL" }

export const initialSelectionState: SelectionState = {
    selectionMode: false,
    selectedIds: [],
}

const sameId = (a: ActivityId, b: ActivityId) => String(a) === String(b)

export function selectionReducer(state: SelectionState, action: SelectionAction): SelectionState {
    switch (action.type) {
        case "START":
            return {
                selectionMode: true,
                selectedIds: action.id == null ? [] : [action.id],
            }
        case "TOGGLE": {
            const selected = state.selectedIds.some((id) => sameId(id, action.id))
            return {
                ...state,
                selectedIds: selected
                    ? state.selectedIds.filter((id) => !sameId(id, action.id))
                    : [...state.selectedIds, action.id],
            }
        }
        case "TOGGLE_ALL":
            return {
                ...state,
                selectedIds: state.selectedIds.length === action.ids.length ? [] : [...action.ids],
            }
        case "CANCEL":
            return initialSelectionState
        default:
            return state
    }
}
